module.exports = __webpack_public_path__ + "static/media/1.2508fa51.jpg";